import { render, staticRenderFns } from "./SearchInputComponent.vue?vue&type=template&id=f3b63b12&scoped=true&"
import script from "./SearchInputComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchInputComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SearchInputComponent.vue?vue&type=style&index=0&id=f3b63b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b63b12",
  null
  
)

export default component.exports